import dayjs from 'dayjs';

export const indexOfClosest = (arr: number[], find: number) => {
    const closest = arr.reduce((prev, curr) => (Math.abs(curr - find) < Math.abs(prev - find) ? curr : prev));
    return arr.indexOf(closest);
};

export const isSorted = (arr: any[]) => {
    return arr.every((v, i, a) => !i || a[i-1] <= v);
};

export const replaceItem = (array: any[], item: any, key: string) => {
    return array.map(obj => obj[key] === item[key] ? item : obj);
};

export const sortByNewest = (arr: any[], attr: string) => {
    return (arr || []).sort((n1, n2) => dayjs(n1[attr]).isAfter(n2[attr]) ? -1 : 1);
};
